var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreenNew", {
    attrs: { size: "lg2", withBgClickEvent: true, modalId: "modal-lv3" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "p-6" }, [
              _c(
                "div",
                { staticClass: "flex items-center justify-between mb-6" },
                [
                  _c(
                    "h2",
                    { staticClass: "text-2xl font-semibold text-gray-900" },
                    [_vm._v("Smart Match Results")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass:
                        "inline-flex items-center px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors",
                      on: { click: _vm.refreshResults },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "w-4 h-4 mr-2",
                          attrs: {
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" Refresh Results "),
                    ]
                  ),
                ]
              ),
              _c("p", { staticClass: "text-gray-600 mb-6" }, [
                _vm._v(
                  " Must-Haves and Nice-to-Haves can be toggled on/off to refresh results. "
                ),
              ]),
              _c("div", { staticClass: "mb-6" }, [
                _c(
                  "h3",
                  { staticClass: "text-lg font-medium text-gray-900 mb-3" },
                  [_vm._v("Must-Haves")]
                ),
                _c(
                  "div",
                  { staticClass: "flex flex-wrap gap-2" },
                  _vm._l(_vm.availableMustHaveFilters, function (filter) {
                    return _c(
                      "button",
                      {
                        key: filter.key,
                        class: [
                          "px-3 py-1.5 rounded-full text-sm font-medium transition-colors",
                          filter.active
                            ? "bg-gray-900 text-white"
                            : "bg-gray-200 text-gray-700 hover:bg-gray-300",
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.toggleMustHave(filter.key)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(filter.label) + " ")]
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "mb-6" }, [
                _c(
                  "h3",
                  { staticClass: "text-lg font-medium text-gray-900 mb-3" },
                  [_vm._v("Nice-to-Haves")]
                ),
                _c(
                  "div",
                  { staticClass: "flex flex-wrap gap-2" },
                  _vm._l(_vm.availableNiceToHaveFilters, function (filter) {
                    return _c(
                      "button",
                      {
                        key: filter.key,
                        class: [
                          "px-3 py-1.5 rounded-full text-sm font-medium transition-colors",
                          filter.active
                            ? "bg-gray-900 text-white"
                            : "bg-gray-200 text-gray-700 hover:bg-gray-300",
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.toggleNiceToHave(filter.key)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(filter.label) + " ")]
                    )
                  }),
                  0
                ),
              ]),
              _c(
                "div",
                { staticClass: "mb-8 flex items-center justify-between" },
                [
                  _c("div", { staticClass: "flex-1 max-w-md" }, [
                    _c("div", { staticClass: "relative" }, [
                      _c(
                        "svg",
                        {
                          staticClass:
                            "absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400",
                          attrs: {
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
                            },
                          }),
                        ]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchQuery,
                            expression: "searchQuery",
                          },
                        ],
                        staticClass:
                          "w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
                        attrs: {
                          type: "text",
                          placeholder: "Search by Resource name",
                        },
                        domProps: { value: _vm.searchQuery },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchQuery = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex items-center space-x-2" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "w-5 h-5",
                        attrs: {
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z",
                            stroke: "#D97706",
                            fill: "#D97706",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "h3",
                      { staticClass: "text-lg font-medium text-gray-900" },
                      [_vm._v("Top Picks: " + _vm._s(_vm.bookmarkedCount))]
                    ),
                  ]),
                ]
              ),
              _vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "flex justify-center items-center py-12" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center space-x-3" },
                        [
                          _c("div", {
                            staticClass:
                              "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600",
                          }),
                          _c("span", { staticClass: "text-gray-600" }, [
                            _vm._v("Running Smart Match algorithm..."),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm.profileResults.length === 0
                ? _c("div", { staticClass: "text-center py-12" }, [
                    _c("div", { staticClass: "text-gray-500" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "mx-auto h-12 w-12 text-gray-400 mb-4",
                          attrs: {
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "h3",
                        {
                          staticClass: "text-lg font-medium text-gray-900 mb-2",
                        },
                        [_vm._v("No matches found")]
                      ),
                      _c("p", { staticClass: "text-gray-500" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.searchQuery
                                ? "Try adjusting your search query or"
                                : "Try adjusting your"
                            ) +
                            " Smart Match criteria to find more resources. "
                        ),
                      ]),
                    ]),
                  ])
                : _c(
                    "div",
                    { staticClass: "space-y-6" },
                    _vm._l(_vm.profileResults, function (profile) {
                      return _c("SmartMatchProfileCard", {
                        key: profile.id,
                        attrs: {
                          profile: profile,
                          "manager-id": _vm.managerId,
                          "admin-id": _vm.adminId,
                          "project-id": _vm.projectId,
                          "current-user-id": _vm.currentUserId,
                        },
                        on: {
                          "favorite-toggled": _vm.handleFavoriteToggled,
                          "bookmark-toggled": _vm.handleBookmarkToggled,
                          "chat-clicked": _vm.handleChatClicked,
                        },
                      })
                    }),
                    1
                  ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }